import React from 'react';
import classNames from 'classnames';
import SuccessIcon from './assets/success.component.svg';
import './dish-add-checkbox.scss';

export const DishAddCheckbox = ({ show = true }) => {
    const rootClasses = classNames({
        dishAddCheckbox: true,
        withBorder: !show,
    });
    return (
        <div className={rootClasses}>
            {show && <SuccessIcon className="dishAddCheckboxIcon" />}
        </div>
    );
};
